import {
  Box,
  Typography,
  IconButton,
  Alert,
  Modal,
  Button,
  Stack,
  Card,
  ListItem,
  Avatar,
  ListItemText,
  Chip,
  Grid,
  ImageListItem,
  ImageList
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import InfoIcon from "@mui/icons-material/Info";
import { useEffect, useState } from "react";
import Loader from "../../../common/Loader";
import { getFormattedAddress } from "../../common/GetFormattedAddress";
import { English } from "../../../constant/EnglishFallback";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../../request/Postrequest";
import {
  DELETE_TIMESHEETS,
  FETCH_TIMESHEET_ENTRIES,
  FETCH_TIMESHEETS,
  FETCH_TIMESHEETS_GOALS
} from "../../../constant/Apipath";
import PlaceholderImg from "../../../assets/images/placeholder_img.jpg";

const formatNumericToTime = (numericValue) => {
  if (numericValue === undefined || numericValue === null) {
    return "00:00";
  }

  let formattedHours = "00";
  let formattedMinutes = "00";
  let finaltime = "00";

  if (numericValue.toString().includes(".")) {
    let [hoursPart, minutesPart] = numericValue.toString().split(".");

    if (hoursPart !== 0) {
      const hours = parseInt(hoursPart) || 0;
      const minutes = minutesPart;
      formattedHours = hours.toString().padStart(2, "0");
      formattedMinutes =
        minutes.toString().length === 1 ? minutes.toString().padEnd(2, "0") : minutes;
      finaltime = `${formattedHours}:${formattedMinutes}`;
    } else {
      formattedMinutes =
        minutesPart.toString().length === 1
          ? `00:${minutesPart.toString().padEnd(2, "0")}`
          : `00:${minutesPart}`;
      finaltime = `${formattedMinutes}`;
    }
  } else {
    let hoursPart = numericValue.toString();
    formattedHours =
      hoursPart.length === 1
        ? `${hoursPart.toString().padStart(2, "0")}:00`
        : hoursPart.length === 2
          ? `${hoursPart}:00`
          : hoursPart;
    finaltime = `${formattedHours}`;
  }

  return `${finaltime}`;
};

const TimesheetViewModal = ({ 
  open, 
  onClose, 
  seletetdTimesheet, 
  loginData,
  isSmallScreen = false,
  onEdit,
  onSend,
  onPictureViewerOpen,
  onDeleteComplete
}) => {
  // Self-managed state (moved from context)
  const [loadingViewModel, setLoadingViewModel] = useState(true);
  const [timeSheetEnteries, setTimeSheetEntries] = useState([]);
  const [timesheetDetail, setTimesheetDetail] = useState([]);
  const [totalTime, setTotalTime] = useState([]);
  const [totalDistance, setTotalDistance] = useState([]);

  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.TimeSheet || {};
  const {
    TEXT_VIEW_TIMESHEET = English.TimeSheet.TEXT_VIEW_TIMESHEET,
    TEXT_TOTAL_CAPS = English.TimeSheet.TEXT_TOTAL_CAPS,
    BUTTON_EDIT = English.TimeSheet.BUTTON_EDIT,
    BUTTON_SEND = English.TimeSheet.BUTTON_SEND,
    TEXT_LAST_MODIFIED = English.TimeSheet.TEXT_LAST_MODIFIED,
    TEXT_KM = English.TimeSheet.TEXT_KM,
    TEXT_MI = English.TimeSheet.TEXT_MI,
    TEXT_SENT_WARNING = English.TimeSheet.TEXT_SENT_WARNING
  } = LanguageData || {};

  // Fetch timesheet data when modal opens
  useEffect(() => {
    if (seletetdTimesheet && open) {
      setLoadingViewModel(true);
      Promise.all([getTimeSheetGoles(), onTimesheetclick()]).finally(() =>
        setLoadingViewModel(false)
      );
    }
  }, [seletetdTimesheet, open]);

  const onTimesheetclick = async () => {
    try {
      setLoadingViewModel(true);
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        SearchList: [{ id: seletetdTimesheet?.id }]
      };
      const getResponse = await Postrequestcall(FETCH_TIMESHEETS, obj, loginData?.accessToken);

      if (getResponse?.status === 200) {
        setTimesheetDetail(getResponse?.data?.data);
      }
    } catch (error) {
      console.error("onTimesheetclick-> Error While Fetching Timesheet: ", error);
    }
  };

  const getTimeSheetGoles = async () => {
    try {
      const sendObj = {
        PageNr: 1,
        NrOfRecPerPage: 10,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        SearchList: [{ TimesheetId: seletetdTimesheet?.id }]
      };

      const getTimesheetGoals = await Postrequestcall(
        FETCH_TIMESHEETS_GOALS,
        sendObj,
        loginData?.accessToken
      );

      const sendEnObj = {
        PageNr: 1,
        NrOfRecPerPage: 10,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        SearchList: [{ TimesheetId: seletetdTimesheet?.id }]
      };

      const fetchResponse = await Postrequestcall(
        FETCH_TIMESHEET_ENTRIES,
        sendEnObj,
        loginData?.accessToken
      );

      const timesheetsEntries = fetchResponse?.data?.data;

      const totalDistance = timesheetsEntries?.reduce(
        (total, item) => total + Number(item.distance),
        0
      );
      const totalTimes = timesheetsEntries?.reduce((total, item) => total + Number(item.hours), 0);

      let a = [];
      const newTimeSheetData = timesheetsEntries?.map((unique) => {
        a = unique;
        a["timesheetGoalsArray"] = [];
        getTimesheetGoals?.data.data?.map((item) => {
          if (item.timeSheetEntryId == unique.id) {
            let obj = {
              id: item.id,
              key: item.goalId,
              value: item.goalName,
              goalName: item.goalName,
              categoryName: item.goalCategoryName,
              categoryId: item.goalCategoryId,
              time: item.hours,
              goalId: item.goalId,
              siteId: item.siteId,
              siteName: item.siteName,
              timeSheetEntryId: item.timeSheetEntryId,
              timeSheetId: item.timeSheetId
            };
            a["timesheetGoalsArray"].push(obj);
          }
        });
        return a;
      });

      setTimeSheetEntries(newTimeSheetData);
      setTotalDistance(totalDistance);
      setTotalTime(formatNumericToTime(totalTimes));
    } catch (error) {
      console.error("getTimeSheetGoles-> Error While Fetching Goals: ", error);
    }
  };

  const getAddress = (params) => {
    const userAddress = {
      city: params?.siteCity,
      country: params?.siteCountry,
      province: params?.siteProvince,
      postalCode: params?.sitePostalCode,
      address: params?.siteAddress
    };
    let { city, country, province, postalCode, address, address1 } = userAddress ? userAddress : {};
    city =
      city !== "" && city
        ? city.replace(/\w*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
        : "";
    country =
      country !== "" && country
        ? country.replace(
            /\w*/g,
            (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
          )
        : "";

    const uAddress = getFormattedAddress(
      address ?? "",
      address1 ?? "",
      city ?? "",
      province ?? "",
      country ?? "",
      postalCode ?? "",
      3
    );
    return uAddress;
  };

  const handleDeleteClick = async (detail) => {
    try {
      const deleteObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: false,
        ReturnRecordError: true,
        DeleteList: [
          {
            Id: detail?.id,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      await Postrequestcall(DELETE_TIMESHEETS, deleteObj, loginData?.accessToken);
      
      // Notify parent component of successful delete
      if (onDeleteComplete) {
        await onDeleteComplete();
      }
      
      handleCloseModal();
    } catch (error) {
      console.error("Failed to delete timesheet:", error);
      alert("Failed to delete timesheet. Please try again.");
    }
  };

  function calculateWorkedHours(clockInTime, clockOutTime) {
    if (!clockInTime || !clockOutTime) return "00:00";

    const [inHours, inMinutes] = clockInTime.split(":").map(Number);
    const [outHours, outMinutes] = clockOutTime.split(":").map(Number);

    const inDate = new Date();
    inDate.setHours(inHours, inMinutes, 0, 0);

    const outDate = new Date();
    outDate.setHours(outHours, outMinutes, 0, 0);

    // Handle next day scenario
    if (outDate <= inDate) {
      outDate.setDate(outDate.getDate() + 1);
    }

    const diffMs = outDate - inDate;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    const pad = (n) => String(n).padStart(2, "0");

    return `${pad(diffHours)}:${pad(diffMinutes)}`;
  }

  const handleCloseModal = () => {
    // Reset state when closing
    setLoadingViewModel(true);
    setTimeSheetEntries([]);
    setTimesheetDetail([]);
    setTotalTime([]);
    setTotalDistance([]);
    onClose();
  };

  const handleEditTimesheet = (detail) => {
    if (onEdit) {
      onEdit(detail, timeSheetEnteries);
    }
  };

  const handleSendClick = () => {
    if (onSend) {
      onSend(timesheetDetail);
    }
  };

  return (
    <Modal open={open} onClose={handleCloseModal}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6">{TEXT_VIEW_TIMESHEET}</Typography>
          <Stack flexDirection={"row"}>
            <IconButton onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>
        
        {loadingViewModel ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "450px"
            }}>
            <Loader />
          </Box>
        ) : (
          <Box>
            {timesheetDetail?.map((detail, index) => (
              <Stack key={detail?.id} gap={1.5}>
                <Stack>
                  <Typography sx={{ color: "text.secondary" }}>
                    {moment(detail?.timesheetDate).format("MMMM DD, YYYY")}
                  </Typography>
                </Stack>
                
                <Box sx={{ maxHeight: "300px", overflow: "auto", scrollbarWidth: "none" }}>
                  <Stack gap={1.5}>
                    {timeSheetEnteries.map((item, index) => (
                      <Card
                        key={index.toString()}
                        className="pagelist-content"
                        sx={{ marginTop: "0px", padding: 2, cursor: "pointer" }}>
                        <Typography variant="body1">{item.companyName}</Typography>
                        <ListItem
                          alignItems="flex-start"
                          sx={{ m: 0, p: 0, pt: 0.5 }}
                          key={index.toString()}
                          secondaryAction={
                            <Stack flexDirection={"column"} alignItems={"center"}>
                              <Typography variant="body1" fontWeight={"bold"}>
                                {detail?.timesheetTypeName === "Clock In" ? (
                                  <>{calculateWorkedHours(item?.clockInTime, item?.clockOutTime)}</>
                                ) : (
                                  <>{formatNumericToTime(item?.hours)}</>
                                )}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "text.secondary"
                                }}>{`${item?.distance} ${item?.unitOfDistance}`}</Typography>
                            </Stack>
                          }>
                          <Avatar
                            className="add-Timesheet-picture"
                            variant="square"
                            alt="contact-PictureUrl"
                            src={item?.mainPictureUrl || item?.projectPictures || PlaceholderImg}
                          />
                          <ListItemText
                            sx={{ pl: 2, mt: 0, alignItems: "flex-start" }}
                            primary={
                              <Typography variant="body1" maxWidth={"430px"} noWrap>
                                {item?.projectName}
                              </Typography>
                            }
                            secondary={
                              <Box>
                                <Typography variant="body2" maxWidth={"430px"} noWrap>
                                  {item?.siteName}
                                </Typography>
                                <Typography variant="body2" maxWidth={"430px"} noWrap>
                                  {getAddress(item)}
                                </Typography>
                              </Box>
                            }
                          />
                        </ListItem>
                        
                        <Stack spacing={0.7}>
                          <Stack>
                            {item?.timesheetGoalsArray?.map((value, index) => {
                              return (
                                <Stack
                                  key={value?.id}
                                  direction={"row"}
                                  gap={1}
                                  justifyContent={"space-between"}
                                  alignItems={"center"}
                                  style={{ margin: "5px" }}>
                                  <Chip label={value.goalName} />
                                  <Typography>{formatNumericToTime(value?.time)}</Typography>
                                </Stack>
                              );
                            })}
                          </Stack>
                          <Stack>
                            <Typography>{item?.comments}</Typography>
                          </Stack>
                          {item?.pictureList?.length !== 0 && (
                            <Stack>
                              <Grid
                                size={{ xs: 12, sm: 12, md: 12 }}
                                sx={{ height: isSmallScreen ? 90 : 130 }}>
                                <ImageList
                                  gap={7.5}
                                  sx={{
                                    width: "100%",
                                    height: "100%",
                                    margin: 0,
                                    padding: 0,
                                    flexWrap: "nowrap",
                                    overflowX: "auto",
                                    display: "flex",
                                    scrollbarWidth: "none",
                                    borderRadius: "10px",
                                    backgroundColor: "white"
                                  }}>
                                  {item?.pictureList.map((picItem, picIndex) => (
                                    <ImageListItem
                                      key={picIndex}
                                      sx={{ minWidth: isSmallScreen ? 90 : 130 }}>
                                      <img
                                        src={
                                          picItem?.pictureUrl
                                            ? picItem?.pictureUrl
                                            : URL.createObjectURL(picItem)
                                        }
                                        style={{
                                          borderRadius: 10,
                                          width: isSmallScreen ? 90 : 130,
                                          height: isSmallScreen ? 90 : 130,
                                          objectFit: "cover",
                                          cursor: "pointer"
                                        }}
                                        alt="Expenses"
                                        loading="lazy"
                                        onClick={() => {
                                          if (onPictureViewerOpen) {
                                            onPictureViewerOpen(item?.pictureList, picIndex);
                                          }
                                        }}
                                      />
                                    </ImageListItem>
                                  ))}
                                </ImageList>
                              </Grid>
                            </Stack>
                          )}
                        </Stack>
                      </Card>
                    ))}
                  </Stack>
                </Box>
                
                <Stack direction={"row"} spacing={2}>
                  <Typography sx={{ color: "text.secondary" }}>{TEXT_TOTAL_CAPS}</Typography>
                  <Typography variant="body1" fontWeight={"bold"}>
                    {formatNumericToTime(detail?.totalHours)}
                  </Typography>
                  <Typography variant="body1" fontWeight={"bold"}>
                    {`${totalDistance} ${detail?.unitOfDistance === "km" ? TEXT_KM : TEXT_MI}`}
                  </Typography>
                </Stack>
                
                {detail?.isSent && (
                  <Alert icon={<InfoIcon />} severity="warning">
                    {TEXT_SENT_WARNING}
                  </Alert>
                )}
                
                <Stack direction={"row"} spacing={2}>
                  {detail?.timesheetTypeName === "Clock In" ? (
                    <Button
                      fullWidth
                      color="error"
                      variant="outlined"
                      onClick={() => {
                        handleDeleteClick(detail);
                      }}>
                      {"Delete"}
                    </Button>
                  ) : (
                    <Button
                      fullWidth
                      color="primary"
                      variant="outlined"
                      onClick={() => {
                        handleEditTimesheet(detail);
                      }}>
                      {BUTTON_EDIT}
                    </Button>
                  )}

                  <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    onClick={handleSendClick}>
                    {BUTTON_SEND}
                  </Button>
                </Stack>
                
                <Stack alignItems={"flex-end"}>
                  <Typography sx={{ color: "text.secondary" }}>
                    {TEXT_LAST_MODIFIED} {moment(detail?.dateModified).format("YYYY-DD-MM h:mm a")}
                  </Typography>
                </Stack>
              </Stack>
            ))}
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default TimesheetViewModal;
